"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTooltip = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledTooltip = styled_components_1.default.img `
  height: 12px;
  margin: 0 5px;
`;
